module.exports = __webpack_public_path__ + "img/training-0-2.cbaa7719.jpg";